import React from "react";

const stats = [
  { label: "Ажиллах горим", value: "4 өдөр", meta: "7 хоногийн уян хуваарь" },
  { label: "Өдрийн ачаалал", value: "4 цаг", meta: "Ахмадын биед тохирсон" },
  { label: "Нэмэлт орлого", value: "415,800₮+", meta: "Сарын боломжит орлого" },
  { label: "Эхний шат", value: "300 ахмад", meta: "Дархан сумын зорилтот хамрах хүрээ" },
];

const jobs = [
  {
    title: "Иргэдийн үйлчилгээний чиглүүлэгч",
    text: "Үйлчилгээний цэг дээр иргэдийг мэдээлэл, урсгалаар чиглүүлнэ.",
    tag: "Хөнгөн үйлчилгээ",
  },
  {
    title: "Ахмад зөвлөх, ментор",
    text: "Залуу ажилтан, сурагч, иргэний бүлгүүдэд туршлага, зөвлөгөө өгнө.",
    tag: "Туршлага дамжуулах",
  },
  {
    title: "Соёл, номын сангийн туслах",
    text: "Арга хэмжээ, уншигч бүртгэл, орон нутгийн өв соёлын ажилд оролцоно.",
    tag: "Олон нийттэй ажил",
  },
  {
    title: "Эрүүл мэндийн байгууллагын чиглүүлэгч",
    text: "Хүлээлгийн урсгал, мэдээлэл, иргэдтэй харилцах ажлыг дэмжинэ.",
    tag: "Иргэдтэй харилцах",
  },
  {
    title: "Архив, бичиг хэргийн туслах",
    text: "Материал ангилах, бүртгэл хөтлөх, баримт цэгцлэх ажилд оролцоно.",
    tag: "Нягт нямбай ажил",
  },
  {
    title: "Орчны халамж, ногоон байгууламж",
    text: "Байгууллагын орчны жижиг хяналт, цэцэрлэгжүүлэлтийн ажилд дэмжлэг үзүүлнэ.",
    tag: "Орчны халамж",
  },
];

const steps = [
  "Ахмад бүртгүүлнэ",
  "Ур чадвар, эрүүл мэндийн үнэлгээ",
  "Тохирох ажлын төрөл сонгоно",
  "Богино чиглүүлэх сургалт",
  "Байгууллагатай холбож гэрээлнэ",
  "Цаг, үр дүн, цалинг баталгаажуулна",
];

const outcomes = [
  {
    title: "Аюулгүй, уян хатан ажил",
    text: "Шөнийн болон өндөр эрсдэлтэй ажилд оруулахгүй, ахмад настанд тохирсон орчин бүрдүүлнэ.",
  },
  {
    title: "Бодит нэмэлт орлого",
    text: "Тэтгэврийн орлогыг дэмжих тогтмол, богино цагийн хөдөлмөрийн сувгийг нээнэ.",
  },
  {
    title: "Нийгмийн оролцоо",
    text: "Ахмадын туршлага, харилцаа, ур чадварыг орон нутгийн хөгжилтэй дахин холбоно.",
  },
];

const pillars = [
  "Аюулгүй ажил",
  "Уян хатан цаг",
  "Туршлага шаардсан үүрэг",
  "Байгууллага-ахмадын бодит холболт",
];

const partners = [
  "Дархан сумын ЗДТГ",
  "Ахмадын хороо",
  "Хөдөлмөрийн хэлтэс",
  "Эрүүл мэндийн төв",
  "Соёлын байгууллагууд",
];

function HeroVector() {
  return (
    <svg viewBox="0 0 520 360" className="blocks-hero-vector" aria-hidden="true">
      <defs>
        <linearGradient id="heroGlow" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#e8f1ff" />
          <stop offset="100%" stopColor="#cfe0ff" />
        </linearGradient>
      </defs>
      <rect x="42" y="40" width="436" height="280" rx="34" fill="url(#heroGlow)" />
      <rect x="70" y="78" width="202" height="198" rx="28" fill="#ffffff" stroke="#d8e4fb" />
      <circle cx="140" cy="130" r="28" fill="#cfd4dc" />
      <circle cx="140" cy="138" r="22" fill="#ffd6b8" />
      <path d="M119 128c5-18 21-29 39-29 11 0 20 3 28 11" fill="none" stroke="#8a94a6" strokeWidth="5" strokeLinecap="round" />
      <path d="M111 216c14-28 34-40 62-40 27 0 49 12 62 40" fill="#2f6fed" opacity="0.12" />
      <path d="M114 214c16-24 35-34 59-34s43 10 59 34" fill="none" stroke="#2f6fed" strokeWidth="14" strokeLinecap="round" />
      <path d="M217 198l15 12" stroke="#101828" strokeWidth="5" strokeLinecap="round" />
      <path d="M233 208v46" stroke="#101828" strokeWidth="5" strokeLinecap="round" />
      <rect x="290" y="84" width="148" height="88" rx="22" fill="#ffffff" stroke="#d8e4fb" />
      <circle cx="326" cy="116" r="12" fill="#2f6fed" opacity="0.16" />
      <path d="M321 116h10M326 111v10" stroke="#2f6fed" strokeWidth="4" strokeLinecap="round" />
      <rect x="348" y="106" width="54" height="10" rx="5" fill="#bfd0f4" />
      <rect x="348" y="127" width="68" height="9" rx="4.5" fill="#dce7fb" />
      <rect x="348" y="145" width="44" height="9" rx="4.5" fill="#dce7fb" />
      <rect x="284" y="188" width="162" height="94" rx="24" fill="#101828" />
      <rect x="304" y="206" width="54" height="10" rx="5" fill="#31415f" />
      <rect x="304" y="223" width="74" height="10" rx="5" fill="#31415f" />
      <path d="M306 255c16-18 29-24 45-16 15 7 24 24 40 20 16-5 23-23 34-27" fill="none" stroke="#87e6b4" strokeWidth="6" strokeLinecap="round" />
      <rect x="96" y="286" width="150" height="32" rx="16" fill="#ffffff" stroke="#d8e4fb" />
      <circle cx="121" cy="302" r="8" fill="#2f6fed" />
      <rect x="137" y="297" width="76" height="10" rx="5" fill="#c5d4f2" />
    </svg>
  );
}

function JobVector({ index }) {
  const themes = [
    { bg: "#eef4ff", primary: "#2f6fed", kind: "guide" },
    { bg: "#ecfdf3", primary: "#039855", kind: "mentor" },
    { bg: "#fff4ed", primary: "#ef6820", kind: "library" },
    { bg: "#f5f3ff", primary: "#7a5af8", kind: "health" },
    { bg: "#eef2ff", primary: "#444ce7", kind: "desk" },
    { bg: "#eff8ff", primary: "#1570ef", kind: "garden" },
  ][index % 6];

  return (
    <svg viewBox="0 0 120 120" className="blocks-job-vector" aria-hidden="true">
      <rect x="10" y="16" width="100" height="88" rx="24" fill={themes.bg} />
      <circle cx="40" cy="46" r="12" fill="#cfd4dc" />
      <circle cx="40" cy="50" r="9" fill="#ffd6b8" />
      <path d="M28 82c8-14 18-20 31-20 13 0 22 6 30 18" fill="none" stroke={themes.primary} strokeWidth="8" strokeLinecap="round" />
      {themes.kind === "guide" && <path d="M68 40h20M78 30v20" stroke={themes.primary} strokeWidth="5" strokeLinecap="round" />}
      {themes.kind === "mentor" && <path d="M69 40l8 8 16-18" fill="none" stroke={themes.primary} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />}
      {themes.kind === "library" && <rect x="66" y="34" width="18" height="24" rx="4" fill="#fff" stroke={themes.primary} strokeWidth="3" />}
      {themes.kind === "health" && <path d="M76 32v26M63 45h26" stroke={themes.primary} strokeWidth="5" strokeLinecap="round" />}
      {themes.kind === "desk" && <rect x="63" y="38" width="26" height="18" rx="4" fill="#fff" stroke={themes.primary} strokeWidth="3" />}
      {themes.kind === "garden" && <path d="M77 32c9 6 10 18 0 24-10-6-9-18 0-24Z" fill="#fff" stroke={themes.primary} strokeWidth="3" />}
      <rect x="26" y="90" width="68" height="5" rx="2.5" fill="#ffffff" opacity="0.92" />
    </svg>
  );
}

function ProcessVector({ index }) {
  const palettes = [
    ["#eef4ff", "#2f6fed"],
    ["#ecfdf3", "#039855"],
    ["#fff4ed", "#ef6820"],
    ["#f5f3ff", "#7a5af8"],
    ["#eef2ff", "#444ce7"],
    ["#eff8ff", "#1570ef"],
  ][index % 6];
  const [bg, primary] = palettes;

  return (
    <svg viewBox="0 0 96 96" className="blocks-process-vector" aria-hidden="true">
      <rect x="10" y="10" width="76" height="76" rx="24" fill={bg} />
      <circle cx="34" cy="34" r="9" fill={primary} />
      <path d="M24 62c5-12 13-18 23-18 9 0 18 5 24 14" fill="none" stroke={primary} strokeWidth="7" strokeLinecap="round" />
      <rect x="50" y="28" width="18" height="6" rx="3" fill={primary} opacity="0.28" />
      <rect x="50" y="40" width="24" height="6" rx="3" fill={primary} opacity="0.2" />
    </svg>
  );
}

function ResultVector({ index }) {
  const palettes = [
    ["#eef4ff", "#2f6fed", "#9cbaf6"],
    ["#ecfdf3", "#039855", "#84e1bc"],
    ["#fff4ed", "#ef6820", "#fdcfb4"],
  ][index % 3];
  const [bg, primary, secondary] = palettes;

  return (
    <svg viewBox="0 0 112 88" className="blocks-result-vector" aria-hidden="true">
      <rect x="10" y="12" width="92" height="64" rx="22" fill={bg} />
      <path d="M24 58c12-16 22-24 34-24 11 0 19 5 30 16" fill="none" stroke={primary} strokeWidth="8" strokeLinecap="round" />
      <circle cx="34" cy="32" r="8" fill={secondary} />
      <circle cx="76" cy="30" r="10" fill={primary} opacity="0.18" />
      <circle cx="76" cy="30" r="5" fill={primary} />
    </svg>
  );
}

function Home() {
  return (
    <div className="blocks-home">
      <div className="blocks-shell">
        <div className="blocks-topbar">
          <span>Дархан сумын ахмад настны хөдөлмөр хөгжлийн төсөл</span>
          <span>2026-2028</span>
        </div>

        <header className="blocks-header">
          <a href="#hero" className="blocks-brand">
            <span className="blocks-brand-mark">А</span>
            <span>
              Ахмад настны
              <strong> хөдөлмөр хөгжлийн бирж</strong>
            </span>
          </a>

          <nav className="blocks-nav" aria-label="Үндсэн навигаци">
            <a href="#about">Төслийн тухай</a>
            <a href="#jobs">Ажлын чиглэл</a>
            <a href="#process">Хэрэгжих явц</a>
            <a href="#results">Үр дүн</a>
          </nav>

          <div className="blocks-actions">
            <a href="#jobs" className="blocks-button blocks-button-muted">
              Ажлын чиглэл
            </a>
            <a href="#cta" className="blocks-button">
              Холбогдох
            </a>
          </div>
        </header>

        <main className="blocks-main">
          <section id="hero" className="blocks-hero">
            <div className="blocks-hero-copy">
              <div className="blocks-eyebrow">Туршлага тэтгэвэрт гардаггүй</div>
              <h1>Ахмадын туршлагыг бодит хөдөлмөртэй холбоё.</h1>
              <p>
                Ахмад настны ур чадвар, харилцаа, зөвлөх чадамжийг аюулгүй,
                богино цагийн ажлын боломжтой холбож, байгууллагуудад тогтвортой
                хүний нөөцийн дэмжлэг бий болгоно.
              </p>

              <div className="blocks-hero-actions">
                <a href="#cta" className="blocks-button">
                  Ахмад бүртгүүлэх
                </a>
                <a href="#process" className="blocks-button blocks-button-muted">
                  Хэрэгжих явц
                </a>
              </div>

              <div className="blocks-pillars">
                {pillars.map((item) => (
                  <span key={item} className="blocks-pillar">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            <aside className="blocks-hero-panel">
              <div className="blocks-panel-card blocks-panel-card-accent">
                <HeroVector />
                <div className="blocks-floating-badges" aria-hidden="true">
                  <span>4 өдөр</span>
                  <span>4 цаг</span>
                  <span>415,800₮+</span>
                </div>
                <span className="blocks-panel-kicker">Төслийн гол санаа</span>
                <h2>Хүнд хөдөлмөр бус, туршлага ба зөвлөх чадварт тулгуурласан ажил.</h2>
                <p>
                  Ахмадуудыг чиглүүлэх, зөвлөх, бичиг хэрэг, соёл, иргэдтэй
                  харилцах зэрэг үүрэгт тохируулж холбох нь төслийн үндсэн чиглэл.
                </p>
                <div className="blocks-panel-note">50 байгууллага + 300 ахмад</div>
              </div>

              <div className="blocks-panel-grid">
                <div className="blocks-panel-card blocks-panel-mini">
                  <span className="blocks-mini-label">Аюулгүй байдал</span>
                  <strong>Шөнийн, өндөр, эрсдэлтэй ажилд оруулахгүй</strong>
                </div>
                <div className="blocks-panel-card blocks-panel-mini">
                  <span className="blocks-mini-label">Зорилтот үр дүн</span>
                  <strong>Орлого, оролцоо, байгууллагын дэмжлэгийг хамтад нь өсгөнө</strong>
                </div>
              </div>
            </aside>
          </section>

          <section className="blocks-stats" aria-label="Үндсэн үзүүлэлтүүд">
            {stats.map((stat) => (
              <article key={stat.label} className="blocks-stat-card">
                <span>{stat.label}</span>
                <strong>{stat.value}</strong>
                <p>{stat.meta}</p>
              </article>
            ))}
          </section>

          <section className="blocks-partners" aria-label="Хамтрагч чиглэлүүд">
            <span className="blocks-partners-label">Хамтран хэрэгжүүлэгч талууд</span>
            <div className="blocks-partners-row">
              {partners.map((partner) => (
                <span key={partner} className="blocks-partner-pill">
                  {partner}
                </span>
              ))}
            </div>
          </section>

          <section id="about" className="blocks-section">
            <div className="blocks-section-head">
              <div>
                <span className="blocks-section-label">Төслийн тухай</span>
                <h2>Илүү цэвэр, илүү ойлгомжтой, blocks.so маягийн public homepage.</h2>
              </div>
              <p>
                Ажиллах хүсэлтэй ахмадуудыг эрүүл мэнд, туршлага, цагийн боломжид
                нь тохирсон ажлын хэлбэртэй холбож, орон нутгийн байгууллагуудад
                ахмадад ээлтэй хөдөлмөрийн шинэ бүтэц бүрдүүлнэ.
              </p>
            </div>
          </section>

          <section id="jobs" className="blocks-grid-wrap">
            <div className="blocks-section-head compact">
              <div>
                <span className="blocks-section-label">Ажлын чиглэл</span>
                <h2>Цэвэр card grid дээр суусан гол ажлууд.</h2>
              </div>
              <p>Туршлага, харилцаа, нягт нямбай байдал шаардсан ажлуудыг урд талд гаргав.</p>
            </div>

            <div className="blocks-grid-list">
              {jobs.map((job, index) => (
                <article key={job.title} className="blocks-grid-card">
                  <div className="blocks-grid-visual">
                    <JobVector index={index} />
                  </div>
                  <div className="blocks-grid-content">
                    <span className="blocks-grid-tag">{job.tag}</span>
                    <h3>{job.title}</h3>
                    <p>{job.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section id="process" className="blocks-process">
            <div className="blocks-section-head compact">
              <div>
                <span className="blocks-section-label">Хэрэгжих явц</span>
                <h2>Энгийн, ил тод 6 алхам.</h2>
              </div>
              <p>Ахмад бүртгэлээс эхлээд ажилд холбох, үр дүн баталгаажуулах хүртэл нэг урсгал.</p>
            </div>

            <div className="blocks-process-grid">
              {steps.map((step, index) => (
                <article key={step} className="blocks-process-card">
                  <ProcessVector index={index} />
                  <span className="blocks-step-index">{String(index + 1).padStart(2, "0")}</span>
                  <h3>{step}</h3>
                </article>
              ))}
            </div>
          </section>

          <section id="results" className="blocks-results-wrap">
            <div className="blocks-section-head compact">
              <div>
                <span className="blocks-section-label">Үр дүн</span>
                <h2>Төслийн бодит нөлөө.</h2>
              </div>
            </div>

            <div className="blocks-results">
              {outcomes.map((item, index) => (
                <article key={item.title} className="blocks-result-card">
                  <ResultVector index={index} />
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </section>

          <section id="cta" className="blocks-cta">
            <div>
              <span className="blocks-section-label">Хамтран ажиллах</span>
              <h2>Ахмадын туршлагыг орон нутгийн хэрэгцээтэй шууд холбоё.</h2>
            </div>

            <div className="blocks-cta-actions">
              <a href="mailto:info@mordi.da.gov.mn" className="blocks-button">
                И-мэйл илгээх
              </a>
              <a href="#hero" className="blocks-button blocks-button-muted">
                Дээш буцах
              </a>
            </div>
          </section>

          <footer className="blocks-footer">
            <div>
              <strong>Ахмад настны хөдөлмөр хөгжлийн бирж</strong>
              <p>Дархан сумын ахмадад ээлтэй хөдөлмөрийн шинэ бүтэц.</p>
            </div>
            <div className="blocks-footer-links">
              <a href="#about">Төслийн тухай</a>
              <a href="#jobs">Ажлын чиглэл</a>
              <a href="#cta">Холбоо барих</a>
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
}

export default Home;
